/* ==========================================================================
   Property Filter
   ========================================================================== */

// ...

import Isotope from "isotope-layout";

var propertyFilter = document.getElementById("isotope-list");

if (propertyFilter) {
  window.onload = function () {
    var iso = new Isotope("#isotope-list", {
      itemSelector: ".property",
    });

    var isoMap = new Isotope("#isotope-list-map", {
      itemSelector: ".property",
    });

    // Emit when the filter values have been changed.
    const emitFilterValues = () =>
      document.dispatchEvent(
        new CustomEvent("propertiesFiltered", {
          detail: {
            neighbourhood: neighbourhoodFiltersValue,
            property: propertyTypefiltersValue,
          },
        })
      );

    let neighbourhoodFiltersValue: string = "*";

    document
      .querySelectorAll("#nbh-dropdown-list [data-filter]")
      .forEach((filter) =>
        filter.addEventListener("click", (event) => {
          neighbourhoodFiltersValue =
            (<HTMLElement>event.target).dataset.filter || "*";
          emitFilterValues();
          runCombo();
          let buttonInnerText = (<HTMLElement>event.target).innerHTML;
          let parentButton = document.getElementById("nbh-button-inner");
          parentButton!.innerHTML = buttonInnerText;
        })
      );

    let propertyTypefiltersValue: string = "*";

    document
      .querySelectorAll("#pt-dropdown-list [data-filter]")
      .forEach((filter) =>
        filter.addEventListener("click", (event) => {
          propertyTypefiltersValue =
            (<HTMLElement>event.target).dataset.filter || "*";
          emitFilterValues();
          runCombo();
          let buttonInnerText = (<HTMLElement>event.target).innerHTML;
          let parentButton = document.getElementById("pt-button-inner");
          parentButton!.innerHTML = buttonInnerText;
        })
      );

    function runCombo() {
      var combo = neighbourhoodFiltersValue?.concat(propertyTypefiltersValue);
      iso.arrange({ filter: combo });
    }

    // Sets filter via url hash ie:lowtideproperties.com/properties/#gastown
    var hashID = "." + window.location.hash.substring(1);
    var ptHashID = "";

    if (window.location.hash) {
      document.dispatchEvent(
        new CustomEvent("propertiesFiltered", {
          detail: {
            neighbourhood: hashID,
            property: ptHashID,
          },
        })
      );
      iso.arrange({
        itemSelector: ".property",
        filter: hashID,
      });
      var nbhSelectChange = <HTMLElement>(
        document.getElementById("nbh-dropdown-list")
      );
      nbhSelectChange.dataset.filter = hashID;
      nbhSelectChange.dispatchEvent(new Event("change"));
    }
  };

  // Toggle class on dropdowns to show when button is clicked
  var nbhFilterButton = document.getElementById("nbh-button-drop");
  nbhFilterButton?.addEventListener("click", function () {
    let dropdown = document.getElementById("nbh-dropdown-list");
    let hoverButton = document.getElementById("nbh-filter-buttons-wrap");
    dropdown?.classList.toggle("hovered");
    hoverButton?.classList.toggle("hover");
  });

  var ptFilterButton = document.getElementById("pt-button-drop");
  ptFilterButton?.addEventListener("click", function () {
    let dropdown = document.getElementById("pt-dropdown-list");
    let hoverButton = document.getElementById("pt-filter-buttons-wrap");
    dropdown?.classList.toggle("hovered");
    hoverButton?.classList.add("hover");
  });

  // Close dropdowns when clicking elsewhere on the page
  document.addEventListener("click", function (event) {
    var isNbhClickInside = nbhFilterButton.contains(event.target);
    var isPtClickInside = ptFilterButton.contains(event.target);

    if (!isNbhClickInside) {
      let nbhDropdown = document.getElementById("nbh-dropdown-list");
      let nbhHoverButton = document.getElementById("nbh-filter-buttons-wrap");

      nbhDropdown?.classList.remove("hovered");
      nbhHoverButton?.classList.remove("hover");
    }
    if (!isPtClickInside) {
      let ptDropdown = document.getElementById("pt-dropdown-list");
      let ptHoverButton = document.getElementById("pt-filter-buttons-wrap");

      ptDropdown?.classList.remove("hovered");
      ptHoverButton?.classList.remove("hover");
    }
  });

  // Remove hidden class on dropdowns once page is loaded
  window.addEventListener("load", (event) => {
    let nbhDropdown = document.getElementById("nbh-dropdown-list");
    let ptDropdown = document.getElementById("pt-dropdown-list");
    nbhDropdown?.classList.remove("hidden");
    ptDropdown?.classList.remove("hidden");
  });
}
